import {
  Component, HostBinding, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { WizBasePopUp } from '../wiz-base-popup';
import { WizComponentManager } from '../../../services/core/component/wiz-component.manager';
import { WizPopUp } from '../wiz-popup';
import { WizTranslationManager } from '../../../services/translation/wiz-translation.manager';

/**
 * renderer par défaut de la popUp de confirmation
 * Author LMA
 */
@Component({
  selector: 'toast-renderer',
  templateUrl: './toast.renderer.html'
})
export class ToastRenderer extends WizBasePopUp implements OnInit {
  @HostBinding('style.width') width: string ;
  @HostBinding('style.height') height: string ;
   /** zone de rendu complémentaire */
  @ViewChild('rendererContainer', {read: ViewContainerRef, static: true}) private rendererContainer: ViewContainerRef;

  constructor(public pop: WizPopUp) {
    super();
    this.datas = pop.datas;
    this.parameters = pop;
    this.width = pop.width;
    this.height = pop.height;
  }

  public customRenderer: boolean = false; // il existe un rendu custom
  public showCloseButton: boolean = false; // on affiche le bouton "close"

  public icon : any = null; // l'icone issue des parameters
  public contentStr: string =''; // détail issu des parameters

  ngOnInit(): void {
    // alimentation de l'icone et du détail
    this.icon = this.parameters.icon;
    // on essaye de traduire
    this.contentStr = WizTranslationManager.getInstance().translateKey(this.parameters.contentText);

    // rendu custom
    if (this.parameters.customFactory) {
      WizComponentManager.instance.addChildTo(this.parameters.customFactory,
         this.rendererContainer, {instanceProperties: { data: this.parameters.customFactoryData }});

      this.customRenderer = true;
    }
    // gestion du bouton de fermeture
    this.showCloseButton = this.parameters.showCloseButton;
    // et programmation de la fermeture
    if (this.parameters.timeToLive > 0) {
      setTimeout(() => {this.close();}, this.parameters.timeToLive);
    }
  }

  /** click global */
  public tap(): void {
    // console.log('tapClose');
    if(this.parameters.tapToClose) {
      this.close();
    }
  }

  /** soit timeOut soit click sur btClose */
  public close(): void {
    this.hide();
  }
}
